// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iWFx8","textarea":"styles_textarea__WQMlS"};